/**
 * Unauthorized Page
 *
 * Shown when user tries to access a protected resource without required permissions/roles
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="page unauthorized-page">
      <div className="container">
        <div className="unauthorized-content">
          <h1>403</h1>
          <h2>Unauthorized</h2>
          <p>You don't have permission to access this resource.</p>

          {user ? (
            <div className="actions">
              <button onClick={() => navigate(-1)}>Go Back</button>
              <button onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
            </div>
          ) : (
            <div className="actions">
              <button onClick={() => navigate('/login')}>Login</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
